
import style from './CardTitle.module.css';
const CardTitle = ({ title, colorTitle }: propsTitleCard) => {
  return (
    <div className={style.titleCard} style={{ color: colorTitle }}>{title}</div>
  )
}
export default CardTitle;